import React, { useEffect, useState } from "react";
import {
    Box,
    Flex,
    Text,
    VStack,
    HStack,
    Divider,
    Avatar,
    IconButton,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    useColorModeValue,
    useToast
} from "@chakra-ui/react";
import {
    FaBookOpen,
    FaCalendarAlt,
    FaClipboardList,
    FaDollarSign,
    FaFileAlt,
    FaUniversity,
    FaLock
} from "react-icons/fa";
import Timetable from "./Tab_components/Timetable";
import Fees from "./Tab_components/Fees";
import Profile_student from "../../../Library/Profile_student_library/Profile_student";
import Bus_fee_student from "../../../Bus/Bus_fee/Bus_fee_student";
import { BASE_URL } from "../../../../Globalapi/Globalapi";
// Component to display the Time Table


const StudentDetailsView = () => {

    const [studentData, setStudentData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const toast = useToast();

    const [parentsData, setParentsData] = useState([]); // Initialize as an empty array
    const borderColor = useColorModeValue("gray.200", "gray.700");
    const blueColor = useColorModeValue("blue.600", "white");
    const bgColor = useColorModeValue("blue.100", "blue.900");
    const hoverBgColor = useColorModeValue("blue.200", "blue.800");
    const grayHoverBg = useColorModeValue("gray.200", "gray.700");

    const navigationItems = [
        { icon: FaBookOpen, label: "Student Details" },
        { icon: FaCalendarAlt, label: "Time Table" },
        { icon: FaDollarSign, label: "Fees" },
        { icon: FaDollarSign, label: "Bus Fee" },
        { icon: FaDollarSign, label: "Library" },

    ];

    useEffect(() => {
        const userId = sessionStorage.getItem("user_id"); // Assuming user_id is stored in session
        const fetchStudentData = async () => {
            try {
                const response = await fetch(`${BASE_URL}/student/student_profile.php`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ pass: userId }),
                });
                const data = await response.json();
                console.log('====================================');
                console.log("f",data);
                console.log('====================================');
                if (data.success) {
                    setStudentData(data.data);

                    // Assuming the parent information is in the response, extracting and setting it
                    const parentsData = [
                        {
                            name: data.data.guardian_name, // Guardian's name
                            relation: data.data.relation, // Relation (e.g., Father, Mother, Guardian)
                            phone: data.data.guardian_contact_no, // Guardian's phone number
                            email: data.data.email, // Use student's email or guardian's email as needed
                        }
                    ];

                    // Optionally, you could append more parents data if available in the API response
                    setParentsData(parentsData);
                } else {
                    setError("Failed to fetch student data.");
                    toast({
                        title: "Error",
                        description: "Failed to fetch student data.",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    });
                }
            } catch (err) {
                setError("An error occurred while fetching data.");
                toast({
                    title: "Error",
                    description: "An error occurred while fetching data.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            } finally {
                setLoading(false);
            }
        };

        fetchStudentData();
    }, [toast]);


    return (
        <Box pl={6}
            pb={6}
            pr={6} w="full">
            {/* Tabs for Navigation */}
            <Tabs variant="line" colorScheme="teal">
                <TabList borderBottom="none">
                    {navigationItems.map((item, index) => (
                        <Tab key={index}>
                            <Flex align="center" gap={2}>
                                <item.icon />
                                <Text fontSize="sm">{item.label}</Text>
                            </Flex>
                        </Tab>
                    ))}
                </TabList>

                <TabPanels>
                    {/* "Student Details" Tab Content */}
                    <TabPanel>
                        <Box border="1px" borderRadius="md" p={4} borderColor={borderColor}>
                            <Flex justify="space-between" align="center" borderBottom="1px" pb={4} borderColor={borderColor}>
                                <Text fontSize="lg" fontWeight="medium">
                                    Parents Information
                                </Text>
                                <IconButton
                                    icon={<FaLock />}
                                    size="sm"
                                    aria-label="Lock information"
                                    bg={bgColor}
                                    color={blueColor}
                                    _hover={{ bg: hoverBgColor }}
                                />
                            </Flex>

                            <VStack spacing={4} divider={<Divider />}>
                                {parentsData.map((parent, index) => (
                                    <Flex key={index} w="full" align="center">
                                        <Avatar src="/api/placeholder/48/48" size="md" name={parent.name} mr={4} />
                                        <HStack spacing={8} flex="1" align="start">
                                            <VStack align="start" spacing={0}>
                                                <Text fontWeight="medium">{parent.name}</Text>
                                                <Text fontSize="sm" color="blue.600">
                                                    {parent.relation}
                                                </Text>
                                            </VStack>
                                            <VStack align="start" spacing={0}>
                                                <Text fontSize="sm" color="gray.600">
                                                    Phone
                                                </Text>
                                                <Text fontSize="sm">{parent.phone}</Text>
                                            </VStack>
                                            <VStack align="start" spacing={0}>
                                                <Text fontSize="sm" color="gray.600">
                                                    Email
                                                </Text>
                                                <Text fontSize="sm">{parent.email}</Text>
                                            </VStack>
                                        </HStack>
                                        <IconButton
                                            icon={<FaLock />}
                                            size="sm"
                                            aria-label="Lock"
                                            _hover={{
                                                bg: grayHoverBg,
                                            }}
                                        />
                                    </Flex>
                                ))}
                            </VStack>
                        </Box>
                    </TabPanel>

                    {/* "Time Table" Tab Content */}
                    <TabPanel>
                        <Timetable />
                    </TabPanel>

                    <TabPanel>
                        <Fees />
                    </TabPanel>

                    <TabPanel>
                        <Bus_fee_student />
                    </TabPanel>

                    <TabPanel>
                        <Profile_student />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
};

export default StudentDetailsView;